import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-form-new',
  templateUrl: './form-new.component.html',
  styleUrls: ['./form-new.component.scss']
})
export class FormNewComponent implements OnInit {
  @ViewChild('modalBlogForm') modalBlogForm: TemplateRef<any>;
  @ViewChild('modalBlogRelate') modalBlogRelate: TemplateRef<any>;
  @ViewChild('modalBlogRelateRemove') modalBlogRelateRemove: TemplateRef<any>;


  @Output() initData = new EventEmitter<any>();

  baseUrlImage = environment.ImageUrl;
  bottomImagesForm: FormGroup;
  blogImageSelected: any = null;
  ckEditorText: string = '';
  isLogin: any = 0;
  appUserId: any = 0;
  blogImageUrl: string = "";
  blogPathImage: any = null;
  private modalRef: any;
  categoriesSelect: any = ["SG News", "Promotions", "Funny", "Business", "Food", "TGIF", "Self-Enlightenment", "Home Improvement"];

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private fb: FormBuilder,
    private modalService: NgbModal,
  ) {

  }

  ngOnInit(): void {

    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.appUserId = user.id;
        this.isLogin = 1;
      } else {
        this.isLogin = 0;
      }
    });
  }


  openModalBlogForm(item: any = { text: "", category: "" }) {
    const modal = this.modalBlogForm;
    if (this.isLogin == 0) {
      return this.toastr.error("Please Login First !");
    }

    this.ckEditorText = item?.text;

    item?.bottomBannerImages?.sort((a: any, b: any) => a.id - b.id);
    item?.bottomBannerImages?.map((row: any, index: number) => {
      this.ckEditorText = this.ckEditorText?.replace(
        `$image${index}`,
        `<img src="${this.baseUrlImage + row.imageSrc}" />`
      )
    })
    this.blogImageUrl = item?.image != null ? `${this.baseUrlImage}${item.image}` : "";
    if (item?.metadata == 'null') item.metadata = '';
    this.bottomImagesForm = this.fb.group({
      id: [item?.id, []],
      banner: ["", [Validators.required]],
      title: [item?.title, [Validators.required]],
      author: [item?.author, [Validators.required]],
      category: [item?.category, [Validators.required]],
      metadata: [item?.metadata, []],
    });

    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      windowClass: "form-blog",
    });
  }

  onBottomBannerSelected(files: any, event: any) {
    this.blogImageUrl = "";
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    const file = event.target.files;
    if (file && file[0]) {
      if (file[0].size > 2097152) {
        this.toastr.error("Max File size must be Less than 2MB!");
        return;
      }

      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.blogImageUrl = event.target.result;
      };
      reader.readAsDataURL(file[0]);
    }

    this.blogPathImage = files;
    this.blogImageSelected = <File>files[0];
  }

  async addBottomBanner() {
    try {
      // this.submitted = true;

      const id = this.bottomImagesForm.value.id;

      if (this.bottomImagesForm.invalid && id == null) {
        this.toastr.error("Please fill all forms !");
        return;
      }

      this.local.alertLoading({});

      let formData = new FormData();
      formData.append("title", this.bottomImagesForm.value.title);
      formData.append("category", this.bottomImagesForm.value.category);
      // formData.append('url', this.bottomImagesForm.value.url);
      formData.append("author", this.bottomImagesForm.value.author);
      formData.append("metadata", this.bottomImagesForm.value.metadata);
      formData.append("image", this.blogImageSelected);
      formData.append("adminId", "0");
      formData.append("isAdmin", "1");
      formData.append("createdBy", this.appUserId);
      let method = "add_bottom_banner";
      if (id != null) {
        method = "edit_bottom_banner";
        formData.append("bottomBannerId", id);
      }
      const imgCount = (this.ckEditorText.match(/<img/g) || []).length;


      let ckEditorText = this.ckEditorText
      if (imgCount > 0) {
        const imgTags = this.ckEditorText.match(/<img[^>]*>/g);
        await Promise.all(imgTags.map(async (tag, index) => {
          const src = tag.match(/src="([^"]*)/)[1];
          await fetch(src)
            .then(res => res.blob())
            .then(blob => {
              ckEditorText = ckEditorText.replace(tag, `$image${index}`);
              formData.append(`images[]`, blob, `image${index}.png`);
            })
            .catch((e) => {
              console.log(e, "ERROR IMAGE")
            })
        }));
      }
      formData.append("text", ckEditorText);

      this.auth[method](formData).subscribe(
        (response: any) => {
          Swal.close();

          this.modalService.dismissAll();
          this.initData.emit(response?.body?.slug)
          this.toastr.success(response.message);
        },
        (e) => {
          this.toastr.error(e.error.message);
          Swal.close();
        }
      );
    } catch (e) {
      Swal.close();
      this.toastr.error("Failed to Create News");
    }
  }


  selectedArticleRelate: any = {};
  listArticlesRelated: any = [];
  bottomBannerTarget: any = null;
  banners: any = {};

  optionsRelated = [];
  openModalRelate(item: any = {}, isRemove = false, isDetail = false) {
    const modal = isRemove ? this.modalBlogRelateRemove : this.modalBlogRelate;
    if (this.isLogin == 0) {
      return this.toastr.error("Please Login First !");
    }
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      windowClass: "my-modal sm",
    });

    this.selectedArticleRelate = item;
    const articleIdList = [];
    for (let row of item.related) {
      if (row.bottomBannerId != item.id) {
        articleIdList.push(row.bottomBannerId);
      }
      if (row.bottomBannerTarget != item.id) {
        articleIdList.push(row.bottomBannerTarget);
      }
    }
    this.auth
      .get_bottom_banner_for_related_by_id({
        articleIdList: JSON.stringify(articleIdList),
      })
      .subscribe((resp: any) => {
        if (!isDetail)
          this.selectedArticleRelate.related = resp?.body;
      });
    // this.listArticlesRelated = this.banners.data.filter((row: any) => row.id != item.id);
    this.optionsRelated = [];
    this.auth.get_bottom_banner_for_related(item.id).subscribe((response: any) => {
      const options = [];
      response.body.map((item) => {
        this.optionsRelated.push({
          value: item.id.toString(),
          label: `${item.title} ${item.related > 0 ? "+" + item.related : ""}`,
        });
      });
    });
  }


  addBottomBannerRelate() {
    if (this.bottomBannerTarget == null) {
      this.toastr.error("Please fill all forms !");
      return;
    }

    let formData = new FormData();
    formData.append("bottomBannerId", this.selectedArticleRelate.id);
    formData.append("bottomBannerTarget", this.bottomBannerTarget);

    this.local.alertLoading({});

    this.auth.related_bottom_banner(formData).subscribe(
      (response: any) => {
        Swal.close();

        this.modalService.dismissAll();
        this.initData.emit()
        // this.bottom_banner_image_url_show = 0;
        this.toastr.success(response.message);
      },
      (e) => {
        this.toastr.error(e.error.message);
        Swal.close();
      }
    );
  }



  handleDeleteRelatedArticle(item: any) {
    this.local
      .alertConfirm({
        message: `Are you sure want to delete ${item.title} as Related Article ?`,
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.local.alertLoading({});
          this.auth
            .delete_bottom_banner_for_related_by_id({
              bottomBannerId: this.selectedArticleRelate.id,
              bottomBannerTarget: item.id,
            })
            .subscribe(
              (resp) => {
                this.toastr.success("SUCCESS");
                this.modalService.dismissAll()
                // this.selectedArticleRelate.related = this.selectedArticleRelate.related.filter((row: any) => row.id != item.id);
                this.initData.emit()
                Swal.close();
              },
              (e) => {
                this.modalService.dismissAll()
                this.toastr.error("FAILED");
                Swal.close();
              }
            );
        }
      });
  }

}
